import React from "react";

/**
 * 
 * @param {*} param0 
 * @returns 
 * @deprecated
 * @todo remove
 */
const GMSButton = ({
  name = "",
  type = "button",
  border = "2",
  id = "",
  onClick,
  disabled = false,
  className = "button-outlined",
  "data-testid": dataTestId = undefined,
  ...props
}) => {
  return (
    <button
      type={type}
      className={className}
      id={id}
      disabled={disabled}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {name}
    </button>
  );
};

export default GMSButton;
